import React, { ReactNode, useEffect, useState } from "react";

import styles from './dataDetail.scss'
import { DataType } from './downloadTable.tsx';

type DetailProps = {
  dataType: DataType;
  dataName: string;
  isOpenDataTypeTable: boolean;
  setIsOpenDataTypeTable: React.Dispatch<React.SetStateAction<boolean>>;
  dataDescription: string;
}

type DescriptionProp = {
  dataType: DataType;
  dataName: string;
  isOpenDescription: boolean;
  setIsOpenDescription: React.Dispatch<React.SetStateAction<boolean>>;
}

type ToolProp = {
  dataType: DataType;
  dataName: string;
  isOpenTool: boolean;
  setIsOpenTool: React.Dispatch<React.SetStateAction<boolean>>;
}

type ContentsProp = {
  dataType: DataType;
}

export const Description: React.FC<DescriptionProp> = ({ dataType, dataName, isOpenDescription, setIsOpenDescription }) => {
  return (
    <>
      <div className={styles.background}>
        <h2 className={styles.accordionHeader}>
          <button className={isOpenDescription ? `${styles.accordionTrigger} ${styles.accordionOpen}` : `${styles.accordionTrigger}`} data-panel="accordion-panel-5" onClick={() => setIsOpenDescription(!isOpenDescription)}>
            <span className={styles.accordionLabel}>本ページでダウンロードできるデータ</span>
          </button>
        </h2>
        <div id="accordion-panel-5" className={isOpenDescription ? styles.accordionPanelOpen : styles.accordionPanelClose}>
          <div className={styles.dataTypeTable}>
            <table>
              <thead>
                <tr>
                  <th>データ名</th>
                  <th>提供形式</th>
                  <th>データの内容</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>事業所排出量データ</td>
                  <td>シェープファイル形式</td>
                  <td>化管法に基づき届け出された個別事業所の住所に対応した緯度経度における排出量データ</td>
                </tr>
                <tr>
                  <td>排出量データ</td>
                  <td>csv形式、シェープファイル形式※</td>
                  <td>３次メッシュ（約1km x 約1km）、５倍メッシュ（約5km x 約5km）のエリア（メッシュ）ごとに、個別事業所から届出された排出量、PRTR届出外 排出量（すそ切り以下事業者、PRTR非対象業種事業者、移動体及び家庭からの排出量）のそれぞれ及び合計の排出量データ</td>
                </tr>
                <tr>
                  <td>行政区域（都道府県、市区町村）ごとの届出大気排出量経年データ<br /><b><small>*「経年データ」からDL可能</small></b></td>
                  {/* <td>行政区域（都道府県、市区町村）ごとの届出大気排出量経年データ</td> */}
                  <td>csv形式</td>
                  <td>個別事業所からの排出年度ごとの大気への排出量データを行政区域（都道府県、市区町村）ごとに合計した経年データ<br />行政区域（都道府県、市区町村）に対応した面積及び人口のデータを含む</td>
                </tr>
                <tr>
                  <td>推計濃度データ</td>
                  <td>csv形式、シェープファイル形式※</td>
                  <td>３次メッシュ、５倍メッシュそれぞれの排出量、推計濃度データ、及び人口のデータに対し、年間気象データ等を基データとして、独立行政法人産業技術総合研究所で開発されたAIST-ADMERで計算した３次メッシュ、５倍メッシュごとの推計濃度データ</td>
                </tr>
                <tr>
                  <td>行政区域（都道府県・市区町村）に対応した大気排出量・推計濃度の経年メッシュ統計データ</td>
                  <td>csv形式</td>
                  <td>大気排出量及び推計濃度（３次メッシュ）に行政区域（都道府県、市区町村）情報を付加。<br />それぞれのメッシュに対応した人口総数のデータを含む</td>
                </tr>
                <tr>
                  <td>AIST-ADMER入力用データ</td>
                  <td>csv形式</td>
                  <td>PRTRマップで提供している排出量データ（届出排出量＋届出外排出量）から作成したAIST-ADMER入力用データ<br />届出外推計の個々の排出源からの推計濃度も計算可能</td>
                </tr>
              </tbody>
            </table>
            ※2022年度以降のみ
          </div>
        </div>
      </div>
    </>
  )
}

export const Tool: React.FC<ToolProp> = ({ dataType, dataName, isOpenTool, setIsOpenTool }) => {
  return (
    <div className={styles.background}>
      <h2 className={styles.accordionHeader}>
        <button className={isOpenTool ? `${styles.accordionTrigger} ${styles.accordionOpen}` : `${styles.accordionTrigger}`} data-panel="accordion-panel-2" onClick={() => setIsOpenTool(!isOpenTool)}>
          <span className={styles.accordionLabel}>WKT（Well Known Text）形式への変換プログラム</span>
        </button>
      </h2>
      <div id="accordion-panel-2" className={isOpenTool ? styles.accordionPanelOpen : styles.accordionPanelClose}>
        <p className={styles.accordionText}>
          csv形式のデータからGIS（Geographic Information System）で利用できるWKT（Well Known Text）形式への変換プログラム（Excelマクロ【Excel:18KB】）は<a href="assets/data/000104035.xlsm">こちら</a>です。
        </p>
      </div>
    </div>
  )
}

export const Contents: React.FC<ContentsProp> = ({ dataType }) => {
  if (dataType == 'office') {
    return (
      <div className="section cf" id="section1">
        <h2 className={styles.heading}><span>１．事業所排出量データ（シェープファイル形式）</span></h2>
        <p></p><p>個別事業所データをGIS（Geographic Information System）で利用可能なシェープファイル（Shape file)形式のzipファイルでダウンロードできます。</p>
        <ol><li><a href="https://www.meti.go.jp/policy/chemical_management/law/prtr/6a.html" target="_blank">個別事業所データ（経済産業省）</a></li>
          <li><a href="http://www.env.go.jp/chemi/prtr/kaiji/index.html" target="_blank">個別事業所データ（環境省）</a></li></ol>

        <p>ダウンロード用データの利用例は<a href="/chem/prtr/map_data/PRTRmapdata_example.html">こちら</a>を利用方法は<a href="/chem/prtr/map_data/PRTRmapdata_GIS.html">こちら</a>を御覧ください。</p>

        <ol>
          <li><span className="aly_tx_f_red">* ダウンロード用データを作成する過程で、一部のデータでは数値の切捨処理がされている場合があります。</span></li>
          <li><span className="aly_tx_f_red">　公表されている個別事業所データを御確認ください。</span></li>
          <li><span className="aly_tx_f_red">* 排出量の単位はkg（管理番号２４３ ダイオキシン類はmg-TEQ）です。</span></li>
          <li><span className="aly_tx_f_red">* 緯度・経度（一部）は地理院地図で確認しています。</span></li></ol>
        <p></p>
        <p>更新日：2023年7月26日</p>
        <p><a href="/data/000148219.zip" target="_blank" className="icon-zip">個別事業所排出量データ[zip:7MB]</a></p>
        <p>＊　ダウンロード用データは、令和5年3月公表時のデータを元に作成しています。</p>

        <p><span className="aly_tx_f_blue"><strong>事業所からの大気排出量</strong></span></p>

        <p className="border-enclose"></p>

        <ol>
          <li><strong><span className="aly_tx_f_red">*&nbsp;</span><span className="aly_tx_f_red">「国土数値情報（行政区域 第2.4版 全国 世界測地系</span>）」（国土交通省）</strong></li><strong>

            <li><span className="aly_tx_f_red">（当該ページのURL:</span><a href="https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v2_4.html#prefecture00" target="_blank">https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v2_4.html#prefecture00</a><span className="aly_tx_f_red">）をNITEが加工して作成しました。</span></li>

            <li><span className="aly_tx_f_red">* 「地理院タイル（国土地理院）」(<a className="blank" href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">
              https://maps.gsi.go.jp/development/ichiran.html</a></span><span className="aly_tx_f_red">）を背景地図に利用しています。</span></li>

            <span className="aly_tx_f_red">* 物質データごとに分類尺度（閾値）が異なります。数値データで御確認ください。</span></strong>
        </ol>

      </div>
    )
  }
  else if (dataType == 'exp') { return (<></>) }
  else if (dataType == 'conc') { return (<></>) }
  else if (dataType == 'admer') { return (<></>) }
  else if (dataType == 'statistic') { return (<></>) }
  else if (dataType == 'secular') { return (<></>) }
}

const Detail: React.FC<DetailProps> = ({ dataType, dataName, isOpenDataTypeTable, setIsOpenDataTypeTable, dataDescription }) => {
  return (
    <>
      <h2 className={styles.accordionHeader}>
        <button className={isOpenDataTypeTable ? `${styles.accordionTrigger} ${styles.accordionOpen}` : `${styles.accordionTrigger}`} data-panel="accordion-panel-1" onClick={() => setIsOpenDataTypeTable(!isOpenDataTypeTable)}>
          <span className={styles.accordionLabel}>{dataName}の詳細</span>
        </button>
      </h2>
      <div id="accordion-panel-1" className={isOpenDataTypeTable ? styles.accordionPanelOpen : styles.accordionPanelClose}>
        <div className={styles.html} dangerouslySetInnerHTML={{ __html: dataDescription }} />
      </div>
    </>
  );

  return (
    <>
      <h2 className={styles.accordionHeader}>
        <button className={styles.accordionTrriger} data-panel="accordion-panel-1" onClick={() => setIsOpenDataTypeTable(!isOpenDataTypeTable)}>
          アコーディオンの見出し01<span className={styles.accordionIcon}></span>
        </button>
      </h2>
      <div id="accordion-panel-1" className={isOpenDataTypeTable ? styles.accordionPanelOpen : styles.accordionPanelClose}>
        <p className={styles.accordionText}>
          アコーディオンの内容。アコーディオンの内容。アコーディオンの内容。
        </p>
      </div>
      <div className={styles.option}>
        <input tabIndex={-1} type="checkbox" id="toggle1" className={styles.toggle} />
        <label className={styles.title} for="toggle1">データの詳細</label>
        <div className={styles.content}>
          test
        </div>
      </div>
    </>
  );

  return (
    <div className={styles.option}>
      <input type="checkbox" id="toggle1" className={styles.toggle} />
      <label className={styles.title} for="toggle1">データの詳細</label>
      <div className={styles.content}>
        <div className="section cf" id="section1">
          {/* <h2 className="heading"><span>１．事業所排出量データ（シェープファイル形式）</span></h2> */}
          <h2 className={styles.heading}><span>１．事業所排出量データ（シェープファイル形式）</span></h2>
          <p></p><p>個別事業所データをGIS（Geographic Information System）で利用可能なシェープファイル（Shape file)形式のzipファイルでダウンロードできます。</p>
          <ol><li><a href="https://www.meti.go.jp/policy/chemical_management/law/prtr/6a.html" target="_blank">個別事業所データ（経済産業省）</a></li>
            <li><a href="http://www.env.go.jp/chemi/prtr/kaiji/index.html" target="_blank">個別事業所データ（環境省）</a></li></ol>

          <p>ダウンロード用データの利用例は<a href="/chem/prtr/map_data/PRTRmapdata_example.html">こちら</a>を利用方法は<a href="/chem/prtr/map_data/PRTRmapdata_GIS.html">こちら</a>を御覧ください。</p>

          <ol>
            <li><span className="aly_tx_f_red">* ダウンロード用データを作成する過程で、一部のデータでは数値の切捨処理がされている場合があります。</span></li>
            <li><span className="aly_tx_f_red">　公表されている個別事業所データを御確認ください。</span></li>
            <li><span className="aly_tx_f_red">* 排出量の単位はkg（管理番号２４３ ダイオキシン類はmg-TEQ）です。</span></li>
            <li><span className="aly_tx_f_red">* 緯度・経度（一部）は地理院地図で確認しています。</span></li></ol>
          <p></p>
          <p>更新日：2023年7月26日</p>
          <p><a href="/data/000148219.zip" target="_blank" className="icon-zip">個別事業所排出量データ[zip:7MB]</a></p>
          <p>＊　ダウンロード用データは、令和5年3月公表時のデータを元に作成しています。</p>

          <p><span className="aly_tx_f_blue"><strong>事業所からの大気排出量</strong></span></p>

          {/* <p className="border-enclose"></p> */}

          <ol>
            <li><strong><span className="aly_tx_f_red">*&nbsp;</span><span className="aly_tx_f_red">「国土数値情報（行政区域 第2.4版 全国 世界測地系</span>）」（国土交通省）</strong></li><strong>

              <li><span className="aly_tx_f_red">（当該ページのURL:</span><a href="https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v2_4.html#prefecture00" target="_blank">https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v2_4.html#prefecture00</a><span className="aly_tx_f_red">）をNITEが加工して作成しました。</span></li>

              <li><span className="aly_tx_f_red">* 「地理院タイル（国土地理院）」(<a className="blank" href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">
                https://maps.gsi.go.jp/development/ichiran.html</a></span><span className="aly_tx_f_red">）を背景地図に利用しています。</span></li>

              <span className="aly_tx_f_red">* 物質データごとに分類尺度（閾値）が異なります。数値データで御確認ください。</span></strong>
          </ol>

        </div>
      </div>
    </div>
  );
  if (dataType == 'office') {
    return (
      <div className="section cf" id="section1">
        <h2 className={styles.heading}><span>１．事業所排出量データ（シェープファイル形式）</span></h2>
        <p></p><p>個別事業所データをGIS（Geographic Information System）で利用可能なシェープファイル（Shape file)形式のzipファイルでダウンロードできます。</p>
        <ol><li><a href="https://www.meti.go.jp/policy/chemical_management/law/prtr/6a.html" target="_blank">個別事業所データ（経済産業省）</a></li>
          <li><a href="http://www.env.go.jp/chemi/prtr/kaiji/index.html" target="_blank">個別事業所データ（環境省）</a></li></ol>

        <p>ダウンロード用データの利用例は<a href="/chem/prtr/map_data/PRTRmapdata_example.html">こちら</a>を利用方法は<a href="/chem/prtr/map_data/PRTRmapdata_GIS.html">こちら</a>を御覧ください。</p>

        <ol>
          <li><span className="aly_tx_f_red">* ダウンロード用データを作成する過程で、一部のデータでは数値の切捨処理がされている場合があります。</span></li>
          <li><span className="aly_tx_f_red">　公表されている個別事業所データを御確認ください。</span></li>
          <li><span className="aly_tx_f_red">* 排出量の単位はkg（管理番号２４３ ダイオキシン類はmg-TEQ）です。</span></li>
          <li><span className="aly_tx_f_red">* 緯度・経度（一部）は地理院地図で確認しています。</span></li></ol>
        <p></p>
        <p>更新日：2023年7月26日</p>
        <p><a href="/data/000148219.zip" target="_blank" className="icon-zip">個別事業所排出量データ[zip:7MB]</a></p>
        <p>＊　ダウンロード用データは、令和5年3月公表時のデータを元に作成しています。</p>

        <p><span className="aly_tx_f_blue"><strong>事業所からの大気排出量</strong></span></p>

        <p className="border-enclose"></p>

        <ol>
          <li><strong><span className="aly_tx_f_red">*&nbsp;</span><span className="aly_tx_f_red">「国土数値情報（行政区域 第2.4版 全国 世界測地系</span>）」（国土交通省）</strong></li><strong>

            <li><span className="aly_tx_f_red">（当該ページのURL:</span><a href="https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v2_4.html#prefecture00" target="_blank">https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v2_4.html#prefecture00</a><span className="aly_tx_f_red">）をNITEが加工して作成しました。</span></li>

            <li><span className="aly_tx_f_red">* 「地理院タイル（国土地理院）」(<a className="blank" href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank">
              https://maps.gsi.go.jp/development/ichiran.html</a></span><span className="aly_tx_f_red">）を背景地図に利用しています。</span></li>

            <span className="aly_tx_f_red">* 物質データごとに分類尺度（閾値）が異なります。数値データで御確認ください。</span></strong>
        </ol>

      </div>
    );
  } else if (dataType == 'exp') {
  } else if (dataType == 'conc') {
  } else if (dataType == 'admer') {
  } else if (dataType == 'statistic') {
  } else if (dataType == 'secular') {

  }
}

export default Detail;
